import { LANGUAGE } from "@/common/utils/constants.js";

export const ABOUT_THE_CLIENT_DOCX = {
	[LANGUAGE.en.short]: {
		title: `About the client`,
		confidential: `Disclaimer: For internal purposes only. Do not share client information outside of the organization.`,
		companyConfidential: 'Client’s name is confidential.'
	},
	[LANGUAGE.de.short]: {
		title: `Über den Kunden`,
		confidential: `Haftungsausschluss: Nur für interne Zwecke. Geben Sie Kundeninformationen nicht außerhalb der Organisation weiter.`,
		companyConfidential: 'Der Name des Kunden ist vertraulich.'
	},
	[LANGUAGE.fr.short]: {
		title: `À propos du client`,
		confidential: `Avis de non-responsabilité:à des fins internes uniquement. Ne partagez pas les informations des clients en dehors de l’organisation.`,
		companyConfidential: 'Le nom du client est confidentiel.'
	},
	[LANGUAGE.it.short]: {
		title: `Informazioni sul cliente`,
		confidential: `Dichiarazione di non responsabilità: solo per scopi interni. Non condividere le informazioni sui clienti al di fuori dell'organizzazione.`,
		companyConfidential: 'Il nome del cliente è riservato.'
	},
	[LANGUAGE.ja.short]: {
		title: `クライアントについて`,
		confidential: `免責事項: 内部目的のみに使用します。 顧客情報を組織外と共有しないでください。`,
		companyConfidential: 'クライアントの名前は秘密です'
	},
	[LANGUAGE.es.short]: {
		title: `Acerca del cliente`,
		confidential: `Descargo de responsabilidad: solo para fines internos. No comparta la información del cliente fuera de la organización.`,
		companyConfidential: 'El nombre del cliente es confidencial.'
	},
}
